import './styles.scss'

export default function ShowHide(props) {
  const { hide, onChange } = props
  const color = hide ? 'black' : 'gray'
  let status = <><path stroke="#000" stroke-linejoin="round" stroke-width="1" d="M3 12c5.4-8 12.6-8 18 0-5.4 8-12.6 8-18 0z"/><path stroke="#000" stroke-linejoin="round" stroke-width="1" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/></>
  if (!hide) {
    status = <><path stroke="rgba(0,0,0,.55)" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="m3 5 16 16M11.148 9.123a3 3 0 0 1 3.722 3.752M8.41 6.878C12.674 4.762 17.267 6.47 21 12c-1.027 1.521-2.119 2.753-3.251 3.696m-2.509 1.59C11.076 19.142 6.631 17.38 3 12c1.01-1.496 2.083-2.713 3.196-3.65"/></>
  }
  return (
    <div className={`ShowHide ${color}`} onClick = {() => onChange(!hide)} >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        {status}
      </svg>Show / hide labels on data points
    </div>
  )
}
